import {
  LayoutDashboard, Users, Calendar, FileText, PenLine, CreditCard,
  Mail, Package, Calculator, Settings, Music, Camera, Lightbulb,
  Aperture, Video, Heart, UtensilsCrossed, Building2, Truck, UserCog, ClipboardList, Map, MapPin, Receipt,
  Boxes, Percent, Monitor, Wallet,
} from "lucide-react";

export const MODULES = [
  { key: "dj", label: "DJ / Animateur", icon: Music },
  { key: "son_lumiere", label: "Son & Lumière", icon: Lightbulb },
  { key: "photobooth", label: "Photobooth", icon: Aperture },
  { key: "photo", label: "Photographe", icon: Camera },
  { key: "video", label: "Vidéaste", icon: Video },
  { key: "wedding", label: "Wedding Planner", icon: Heart },
  { key: "traiteur", label: "Traiteur", icon: UtensilsCrossed },
  { key: "agence", label: "Agence événementielle", icon: Building2 },
  { key: "location", label: "Loueur de matériel", icon: Package },
];

export const EVENT_STATUS = {
  prospect: { label: "Prospect", dot: "bg-stone-400", cls: "bg-stone-500/10 text-stone-300 border-stone-500/25" },
  devis_envoye: { label: "Devis envoyé", dot: "bg-[#FF6A00]", cls: "bg-[#FF6A00]/10 text-[#FF6A00] border-[#FF6A00]/25" },
  confirme: { label: "Confirmé", dot: "bg-emerald-400", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" },
  realise: { label: "Réalisé", dot: "bg-blue-400", cls: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  refuse: { label: "Refusé", dot: "bg-red-500", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
  annule: { label: "Annulé", dot: "bg-red-500", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
};

export const QUOTE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
  envoye: { label: "Envoyé", cls: "bg-[#FF6A00]/10 text-[#FF6A00] border-[#FF6A00]/25" },
  accepte: { label: "Accepté", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" },
  refuse: { label: "Refusé", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
  facture: { label: "Facturé", cls: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  paye: { label: "Payé", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" },
  expire: { label: "Expiré", cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
};

export const PIPELINE = [
  { key: "nouveau_lead", label: "Nouveau lead" },
  { key: "devis_envoye", label: "Devis envoyé" },
  { key: "negociation", label: "Négociation" },
  { key: "signe", label: "Signé" },
  { key: "perdu", label: "Perdu" },
];

export const EVENT_CATEGORIES = ["Mariage", "Anniversaire", "Entreprise", "Autre"];

export const EVENT_CATEGORY_COLORS = {
  Mariage: { label: "Mariage", dot: "bg-pink-400", hex: "#f472b6", text: "text-pink-400" },
  Anniversaire: { label: "Anniversaire", dot: "bg-violet-400", hex: "#a78bfa", text: "text-violet-400" },
  Entreprise: { label: "Entreprise", dot: "bg-blue-400", hex: "#60a5fa", text: "text-blue-400" },
  Autre: { label: "Autre", dot: "bg-zinc-400", hex: "#a1a1aa", text: "text-zinc-400" },
};
export const catColor = (c) => EVENT_CATEGORY_COLORS[c] || EVENT_CATEGORY_COLORS.Autre;

export const ROLES = {
  admin: "Administrateur", commercial: "Commercial",
  logistique: "Logistique", technicien: "Technicien",
  chef_logistique: "Chef logistique", chef_technicien: "Chef technicien", ecran: "Écran",
};
export const ASSIGNABLE_ROLES = ["commercial", "logistique", "chef_logistique", "technicien", "chef_technicien", "admin"];

export const TASK_TYPES = {
  chargement: { label: "Chargement", bar: "border-l-[#FF6A00]", badge: "bg-[#FF6A00]/10 text-[#FF6A00]" },
  livraison: { label: "Livraison", bar: "border-l-blue-400", badge: "bg-blue-500/10 text-blue-400" },
  montage: { label: "Montage", bar: "border-l-emerald-400", badge: "bg-emerald-500/10 text-emerald-400" },
  preparation: { label: "Préparation", bar: "border-l-yellow-400", badge: "bg-yellow-500/10 text-yellow-400" },
  administratif: { label: "Administratif", bar: "border-l-purple-400", badge: "bg-purple-500/10 text-purple-400" },
  reparation: { label: "Réparation", bar: "border-l-red-400", badge: "bg-red-500/10 text-red-400" },
  autre: { label: "Autre", bar: "border-l-zinc-400", badge: "bg-zinc-500/10 text-zinc-300" },
  event: { label: "Événement", bar: "border-l-white", badge: "bg-white/10 text-white" },
};

export const NAV = [
  { to: "/app", label: "Tableau de bord", icon: LayoutDashboard, end: true, cat: "home", page: "dashboard", roles: ["admin", "commercial", "logistique", "chef_logistique"] },
  { to: "/app/calendrier", label: "Événements", icon: Calendar, cat: "operations", page: "calendrier", roles: ["admin", "commercial", "logistique", "technicien", "chef_logistique", "chef_technicien"] },
  { to: "/app/planning", label: "Planning", icon: ClipboardList, cat: "operations", page: "planning", roles: ["admin", "commercial", "logistique", "technicien", "chef_logistique", "chef_technicien"] },
  { to: "/app/stock", label: "Catalogue & Matériel", icon: Package, cat: "operations", page: "stock", roles: ["admin", "commercial", "logistique", "chef_logistique"] },
  { to: "/app/chargement", label: "Chargement du jour", icon: Truck, cat: "operations", page: "chargement", roles: ["admin", "logistique", "technicien", "chef_logistique", "chef_technicien"] },
  { to: "/app/livraisons", label: "Livraisons", icon: Map, cat: "operations", page: "livraisons", roles: ["admin", "logistique", "chef_logistique"] },
  { to: "/app/contacts", label: "Contacts", icon: Users, cat: "administratif", page: "contacts", roles: ["admin", "commercial"] },
  { to: "/app/lieux", label: "Lieux", icon: MapPin, cat: "administratif", page: "lieux", roles: ["admin", "commercial", "logistique", "chef_logistique"] },
  { to: "/app/devis", label: "Devis & Factures", icon: FileText, cat: "administratif", page: "devis", roles: ["admin", "commercial"] },
  { to: "/app/comptabilite", label: "Comptabilité", icon: Receipt, cat: "administratif", page: "comptabilite", roles: ["admin"] },
  { to: "/app/notes-de-frais", label: "Notes de frais", icon: Wallet, cat: "administratif", page: "notes-de-frais", always: true, roles: ["admin", "commercial", "logistique", "technicien", "chef_logistique", "chef_technicien"] },
  { to: "/app/equipe", label: "Équipe", icon: UserCog, cat: "administratif", page: "equipe", roles: ["admin"] },
  { to: "/app/entreprise/organisation", label: "Organisation", icon: Building2, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
  { to: "/app/entreprise/modules", label: "Modules", icon: Boxes, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
  { to: "/app/entreprise/commercial", label: "Commercial", icon: Percent, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
  { to: "/app/entreprise/paiements", label: "Paiements", icon: CreditCard, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
  { to: "/app/entreprise/documents", label: "Documents", icon: FileText, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
  { to: "/app/entreprise/ecrans", label: "Écrans", icon: Monitor, cat: "entreprise", page: "entreprise", roles: ["admin"], always: true },
];

export const NAV_CATS = [
  { key: "operations", label: "Opérations" },
  { key: "administratif", label: "Administratif" },
  { key: "entreprise", label: "Entreprise" },
];

export const ENTREPRISE_TAB_MAP = {
  organisation: "org", modules: "modules", commercial: "commercial",
  paiements: "payments", documents: "documents", ecrans: "screen",
};

export const LANDING_PAGES = [
  { value: "/app", label: "Tableau de bord" },
  { value: "/app/calendrier", label: "Événements" },
  { value: "/app/planning", label: "Planning" },
  { value: "/app/stock", label: "Catalogue & Matériel" },
  { value: "/app/contacts", label: "Contacts" },
  { value: "/app/devis", label: "Devis & Factures" },
];

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const frDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};

export const DEFAULT_DOC_TEMPLATE = {
  primary_color: null,
  accent_color: "#FFD500",
  blocks: [
    { type: "brand", visible: true, title: "" },
    { type: "doc_info", visible: true, title: "" },
    { type: "client", visible: true, title: "Client" },
    { type: "lines", visible: true, title: "Prestations" },
    { type: "totals", visible: true, title: "" },
    { type: "payment", visible: true, title: "Conditions de paiement" },
    { type: "notes", visible: true, title: "Notes" },
    { type: "legal", visible: false, title: "Mentions légales", text: "" },
    { type: "signature", visible: false, title: "Bon pour accord" },
    { type: "footer", visible: true, title: "", text: "Propulsé par HalgarOS" },
  ],
};

export const DOC_BLOCK_LABELS = {
  brand: "En-tête entreprise",
  doc_info: "Type & numéro",
  client: "Bloc client",
  lines: "Tableau des prestations",
  totals: "Totaux",
  payment: "Conditions de paiement",
  notes: "Notes",
  legal: "Mentions légales",
  signature: "Signature",
  footer: "Pied de page",
};

